export default "__VITE_ASSET__BhEYE_11__"